import { skipToken } from '@reduxjs/toolkit/query';
import { useDeepCompareMemo } from 'use-deep-compare';
import { useGetVarietyQuery } from '../impl/blfApi/endpoints/varieties';
import { Stage } from '../impl/blfApi/schemas/stage';

export const useStages = (varietyId: string | undefined, skip?: boolean) => {
  const {
    data: variety,
    isLoading,
    isFetching,
  } = useGetVarietyQuery(varietyId ?? skipToken, {
    skip: skip,
  });

  const orderedStages = useDeepCompareMemo<Stage[]>(() => {
    if (variety?.stages) {
      return [...variety.stages].sort((a, b) => a.order - b.order);
    }
    return [];
  }, [variety?.stages]);

  return {
    stages: orderedStages,
    isStagesLoading: isLoading || isFetching,
  };
};
